import * as React from "react";

function SvgStar(props) {
  return (
    <span className="iiht-svg">
      <svg xmlns="http://www.w3.org/2000/svg" width={12.546} height={11.924} {...props}>
        <path
          d="M10.029 7.48a.618.618 0 00-.178.547l.549 3.18a.526.526 0 01-.207.584.673.673 0 01-.4.129.672.672 0 01-.313-.077l-2.919-1.571a.618.618 0 00-.575 0l-2.799 1.575a.673.673 0 01-.709-.051.608.608 0 01-.329-.589l.669-3.251a.618.618 0 00-.178-.547L.2 5.497a.673.673 0 01-.171-.69.673.673 0 01.543-.458l3.17-.556a.618.618 0 00.465-.338L5.67.375A.672.672 0 016.27 0a.673.673 0 01.6.375l1.4 3.079a.618.618 0 00.465.338l3.227.556a.672.672 0 01.543.458.674.674 0 01-.171.69z"
          fill="#039be5"
          data-name="Group 11074"
        />
      </svg>
    </span>
  );
}

export default SvgStar;
